<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择课程年龄"
    @change="handleChange"
  >
    <el-option
      v-for="v in list"
      :key="v.id"
      :label="v.age_name"
      :value="v.id"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-age';

export default {
  props: {
    value: [Number, String],
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ is_only_name: true });
      if (!isError) this.list = data;
    },
    handleChange(valueBackup) {
      const item = this.list.find(v => v.id === valueBackup);
      this.$emit('change', item.age_name);
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.getList();
  },
};
</script>
